export const GET_LICENSE_SALES_SUCCESS = "getLicenseSalesSucces"
export const GET_LICENSE_SALE_SUCCESS = "getLicenseSaleSucces"
export const CHANGE_LICENSE_SALE_STATUS_SUCCESS = "changeLicenseSaleStatusSuccess"